export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_START = 'CREATE_USER_START';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const SIGN_IN_WITH_EMAIL = 'SIGN_IN_WITH_EMAIL';
export const SIGN_IN_WITH_EMAIL_START = 'SIGN_IN_WITH_EMAIL_START';
export const SIGN_IN_WITH_EMAIL_SUCCESS = 'SIGN_IN_WITH_EMAIL_SUCCESS';
export const SIGN_IN_WITH_EMAIL_FAIL = 'SIGN_IN_WITH_EMAIL_FAIL';

export const SIGN_IN_WITH_TOKEN = 'SIGN_IN_WITH_TOKEN';
export const SIGN_IN_WITH_TOKEN_START = 'SIGN_IN_WITH_TOKEN_START';
export const SIGN_IN_WITH_TOKEN_SUCCESS = 'SIGN_IN_WITH_TOKEN_SUCCESS';
export const SIGN_IN_WITH_TOKEN_FAIL = 'SIGN_IN_WITH_TOKEN_FAIL';

export const SIGN_IN_WITH_GOOGLE = 'SIGN_IN_WITH_GOOGLE';
export const SIGN_IN_WITH_GOOGLE_START = 'SIGN_IN_WITH_GOOGLE_START';
export const SIGN_IN_WITH_GOOGLE_SUCCESS = 'SIGN_IN_WITH_GOOGLE_SUCCESS';
export const SIGN_IN_WITH_GOOGLE_FAIL = 'SIGN_IN_WITH_GOOGLE_FAIL';

export const SIGN_IN_WITH_FACEBOOK = 'SIGN_IN_WITH_FACEBOOK';
export const SIGN_IN_WITH_FACEBOOK_START = 'SIGN_IN_WITH_FACEBOOK_START';
export const SIGN_IN_WITH_FACEBOOK_SUCCESS = 'SIGN_IN_WITH_FACEBOOK_SUCCESS';
export const SIGN_IN_WITH_FACEBOOK_FAIL = 'SIGN_IN_WITH_FACEBOOK_FAIL';

export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_START = 'PASSWORD_RESET_START';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAIL = 'UPDATE_PASSWORD_FAIL';

export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_PASSWORD_START = 'SET_PASSWORD_START';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAIL = 'SET_PASSWORD_FAIL';

export const AUTH_STATE_CHANGED = 'AUTH_STATE_CHANGED';
export const AUTH_STATE_CHANGED_START = 'AUTH_STATE_CHANGED_START';
export const AUTH_STATE_CHANGED_SUCCESS = 'AUTH_STATE_CHANGED_SUCCESS';
export const AUTH_STATE_CHANGED_FAIL = 'AUTH_STATE_CHANGED_FAIL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const GET_TASKS_SERVER = 'GET_TASKS_SERVER';
export const GET_TASKS_SERVER_START = 'GET_TASKS_SERVER_START';
export const GET_TASKS_SERVER_SUCCESS = 'GET_TASKS_SERVER_SUCCESS';
export const GET_TASKS_SERVER_FAIL = 'GET_TASKS_SERVER_FAIL';

export const CREATE_TASK_SINGLE = 'CREATE_TASK_SINGLE';
export const CREATE_TASK_SINGLE_START = 'CREATE_TASK_SINGLE_START';
export const CREATE_TASK_SINGLE_SUCCESS = 'CREATE_TASK_SINGLE_SUCCESS';
export const CREATE_TASK_SINGLE_FAIL = 'CREATE_TASK_SINGLE_FAIL';

export const UPDATE_TASK_SINGLE = 'UPDATE_TASK_SINGLE';
export const UPDATE_TASK_SINGLE_START = 'UPDATE_TASK_SINGLE_START';
export const UPDATE_TASK_SINGLE_SUCCESS = 'UPDATE_TASK_SINGLE_SUCCESS';
export const UPDATE_TASK_SINGLE_FAIL = 'UPDATE_TASK_SINGLE_FAIL';

export const REMOVE_TASK_SINGLE = 'REMOVE_TASK_SINGLE';
export const REMOVE_TASK_SINGLE_START = 'REMOVE_TASK_SINGLE_START';
export const REMOVE_TASK_SINGLE_SUCCESS = 'REMOVE_TASK_SINGLE_SUCCESS';
export const REMOVE_TASK_SINGLE_FAIL = 'REMOVE_TASK_SINGLE_FAIL';

export const CREATE_TASK_REGULAR = 'CREATE_TASK_REGULAR';
export const CREATE_TASK_REGULAR_START = 'CREATE_TASK_REGULAR_START';
export const CREATE_TASK_REGULAR_SUCCESS = 'CREATE_TASK_REGULAR_SUCCESS';
export const CREATE_TASK_REGULAR_FAIL = 'CREATE_TASK_REGULAR_FAIL';

export const UPDATE_TASK_REGULAR = 'UPDATE_TASK_REGULAR';
export const UPDATE_TASK_REGULAR_START = 'UPDATE_TASK_REGULAR_START';
export const UPDATE_TASK_REGULAR_SUCCESS = 'UPDATE_TASK_REGULAR_SUCCESS';
export const UPDATE_TASK_REGULAR_FAIL = 'UPDATE_TASK_REGULAR_FAIL';

export const REMOVE_TASK_REGULAR = 'REMOVE_TASK_REGULAR';
export const REMOVE_TASK_REGULAR_START = 'REMOVE_TASK_REGULAR_START';
export const REMOVE_TASK_REGULAR_SUCCESS = 'REMOVE_TASK_REGULAR_SUCCESS';
export const REMOVE_TASK_REGULAR_FAIL = 'REMOVE_TASK_REGULAR_FAIL';

export const CREATE_TASK_DELAYED = 'CREATE_TASK_DELAYED';
export const CREATE_TASK_DELAYED_START = 'CREATE_TASK_DELAYED_START';
export const CREATE_TASK_DELAYED_SUCCESS = 'CREATE_TASK_DELAYED_SUCCESS';
export const CREATE_TASK_DELAYED_FAIL = 'CREATE_TASK_DELAYED_FAIL';

export const UPDATE_TASK_DELAYED = 'UPDATE_TASK_DELAYED';
export const UPDATE_TASK_DELAYED_START = 'UPDATE_TASK_DELAYED_START';
export const UPDATE_TASK_DELAYED_SUCCESS = 'UPDATE_TASK_DELAYED_SUCCESS';
export const UPDATE_TASK_DELAYED_FAIL = 'UPDATE_TASK_DELAYED_FAIL';

export const REMOVE_TASK_DELAYED = 'REMOVE_TASK_DELAYED';
export const REMOVE_TASK_DELAYED_START = 'REMOVE_TASK_DELAYED_START';
export const REMOVE_TASK_DELAYED_SUCCESS = 'REMOVE_TASK_DELAYED_SUCCESS';
export const REMOVE_TASK_DELAYED_FAIL = 'REMOVE_TASK_DELAYED_FAIL';

export const CREATE_TASK_GLOBAL = 'CREATE_TASK_GLOBAL';
export const CREATE_TASK_GLOBAL_START = 'CREATE_TASK_GLOBAL_START';
export const CREATE_TASK_GLOBAL_SUCCESS = 'CREATE_TASK_GLOBAL_SUCCESS';
export const CREATE_TASK_GLOBAL_FAIL = 'CREATE_TASK_GLOBAL_FAIL';

export const UPDATE_TASK_GLOBAL = 'UPDATE_TASK_GLOBAL';
export const UPDATE_TASK_GLOBAL_START = 'UPDATE_TASK_GLOBAL_START';
export const UPDATE_TASK_GLOBAL_SUCCESS = 'UPDATE_TASK_GLOBAL_SUCCESS';
export const UPDATE_TASK_GLOBAL_FAIL = 'UPDATE_TASK_GLOBAL_FAIL';

export const REMOVE_TASK_GLOBAL = 'REMOVE_TASK_GLOBAL';
export const REMOVE_TASK_GLOBAL_START = 'REMOVE_TASK_GLOBAL_START';
export const REMOVE_TASK_GLOBAL_SUCCESS = 'REMOVE_TASK_GLOBAL_SUCCESS';
export const REMOVE_TASK_GLOBAL_FAIL = 'REMOVE_TASK_GLOBAL_FAIL';

export const GET_LABELS = 'GET_LABELS';
export const GET_LABELS_START = 'GET_LABELS_START';
export const GET_LABELS_SUCCESS = 'GET_LABELS_SUCCESS';
export const GET_LABELS_FAIL = 'GET_LABELS_FAIL';

export const CREATE_LABEL = 'CREATE_LABEL';
export const CREATE_LABEL_START = 'CREATE_LABEL_START';
export const CREATE_LABEL_SUCCESS = 'CREATE_LABEL_SUCCESS';
export const CREATE_LABEL_FAIL = 'CREATE_LABEL_FAIL';

export const UPDATE_LABEL = 'UPDATE_LABEL';
export const UPDATE_LABEL_START = 'UPDATE_LABEL_START';
export const UPDATE_LABEL_SUCCESS = 'UPDATE_LABEL_SUCCESS';
export const UPDATE_LABEL_FAIL = 'UPDATE_LABEL_FAIL';

export const REMOVE_LABEL = 'REMOVE_LABEL';
export const REMOVE_LABEL_START = 'REMOVE_LABEL_START';
export const REMOVE_LABEL_SUCCESS = 'REMOVE_LABEL_SUCCESS';
export const REMOVE_LABEL_FAIL = 'REMOVE_LABEL_FAIL';

export const SET_NAMES = 'SET_NAMES';
export const SET_NAMES_START = 'SET_NAMES_START';
export const SET_NAMES_SUCCESS = 'SET_NAMES_SUCCESS';
export const SET_NAMES_FAIL = 'SET_NAMES_FAIL';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LANGUAGE_START = 'SET_LANGUAGE_START';
export const SET_LANGUAGE_SUCCESS = 'SET_LANGUAGE_SUCCESS';
export const SET_LANGUAGE_FAIL = 'SET_LANGUAGE_FAIL';

export const SET_DISABLE_TASKS_DONE = 'SET_DISABLE_TASKS_DONE';
export const SET_DISABLE_TASKS_DONE_START = 'SET_DISABLE_TASKS_DONE_START';
export const SET_DISABLE_TASKS_DONE_SUCCESS = 'SET_DISABLE_TASKS_DONE_SUCCESS';
export const SET_DISABLE_TASKS_DONE_FAIL = 'SET_DISABLE_TASKS_DONE_FAIL';

export const SET_DISABLE_ADVICE_SHOW = 'SET_DISABLE_ADVICE_SHOW';
export const SET_DISABLE_ADVICE_SHOW_START = 'SET_DISABLE_ADVICE_SHOW_START';
export const SET_DISABLE_ADVICE_SHOW_SUCCESS = 'SET_DISABLE_ADVICE_SHOW_SUCCESS';
export const SET_DISABLE_ADVICE_SHOW_FAIL = 'SET_DISABLE_ADVICE_SHOW_FAIL';

export const SET_ADVICE_SHOWED_AT = 'SET_ADVICE_SHOWED_AT';
export const SET_ADVICE_SHOWED_AT_START = 'SET_ADVICE_SHOWED_AT_START';
export const SET_ADVICE_SHOWED_AT_SUCCESS = 'SET_ADVICE_SHOWED_AT_SUCCESS';
export const SET_ADVICE_SHOWED_AT_FAIL = 'SET_ADVICE_SHOWED_AT_FAIL';

export const SET_SHOW_GLOBAL_TASKS_AS_LIST = 'SET_SHOW_GLOBAL_TASKS_AS_LIST';
export const SET_SHOW_GLOBAL_TASKS_AS_LIST_START = 'SET_SHOW_GLOBAL_TASKS_AS_LIST_START';
export const SET_SHOW_GLOBAL_TASKS_AS_LIST_SUCCESS = 'SET_SHOW_GLOBAL_TASKS_AS_LIST_SUCCESS';
export const SET_SHOW_GLOBAL_TASKS_AS_LIST_FAIL = 'SET_SHOW_GLOBAL_TASKS_AS_LIST_FAIL';

export const REGISTER_DEVICE_TOKEN = 'REGISTER_DEVICE_TOKEN';
export const REGISTER_DEVICE_TOKEN_START = 'REGISTER_DEVICE_TOKEN_START';
export const REGISTER_DEVICE_TOKEN_SUCCESS = 'REGISTER_DEVICE_TOKEN_SUCCESS';
export const REGISTER_DEVICE_TOKEN_FAIL = 'REGISTER_DEVICE_TOKEN_FAIL';

export const REFRESH_TASKS = 'REFRESH_TASKS';
export const REFRESH_LABELS = 'REFRESH_LABELS';
export const REFRESH_USER = 'REFRESH_USER';
export const REFRESH_SHOW_GLOBAL_TASKS_AS_LIST = 'REFRESH_SHOW_GLOBAL_TASKS_AS_LIST';
export const REFRESH_DISABLE_TASKS_DONE = 'REFRESH_DISABLE_TASKS_DONE';
export const REFRESH_LANGUAGE = 'REFRESH_LANGUAGE';
export const REFRESH_DISABLE_ADVICE_SHOW = 'REFRESH_DISABLE_ADVICE_SHOW';

export const SET_DARK_MODE = 'SET_DARK_MODE';
export const SET_DARK_MODE_START = 'SET_DARK_MODE_START';
export const SET_DARK_MODE_SUCCESS = 'SET_DARK_MODE_SUCCESS';
export const SET_DARK_MODE_FAIL = 'SET_DARK_MODE_FAIL';
